import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

/*
 *
 * Constants: `@dbh/country-not-available-entry-content`.
 *
 */const TRANSLATION_IDS=Object.freeze({MESSAGE:"components.EntryContentCountryNotAvailable.message"});

var index = createBrowserOnlyLazyComponent(()=>import('./component-b944b2b3.js'/* webpackChunkName: "dbh.country-not-available-entry-content.components" */));// Keep the `export *` at the bottom and the other types of exports above.

export { TRANSLATION_IDS, index as default };
